
import {defineComponent} from 'vue';

export default defineComponent({
  name: "BaseEditButton",
  props: {
    targetRoute: {
      type: Object,
      required: true
    },
    iconClass: {
      type: String,
      required: false,
      default: ''
    }
  },
});
